// extracted by mini-css-extract-plugin
module.exports = {"camino-preview-pane":"_3rEM74khGI8vf7IxSVe9MA","camino-shape":"_1TiE5XawEeetdqu5ACUpLf"};